<template>
    <div>
        <CCol sm="12">
    
    
            <CCol sm="12" style="width: 100%;background-size: cover; margin: auto;color: #fff">
                <CRow class="p-2">
                   
                    <CCol sm="12">
                     <CRow>
                        <CCol sm="4">
                            <CCard class="custom-border-radius-12px" @click="submitClaim" >
                                <div class="text-center m-3">
                                <img src="../assets/img/receipt3.png" style="max-width:50px" />
                                <h3 class="custom-24px-500">Financial Claim</h3>
                                </div>
                                <!-- <button @click="submitClaim" class="btn btn-primary">Submit Claim</button> -->
                            </CCard>
                        </CCol>
                        <CCol sm="4">
                            <CCard class="custom-border-radius-12px">
                                <div class="text-center m-3">
                                    <img src="../assets/img/overtime.png" style="max-width:50px" />
                                    <h3 class="custom-24px-500">Overtime Claim</h3>
                                </div>
                               
                            </CCard>
                        </CCol>
                        <CCol sm="4">
                            <CCard class="bg-F2F4F7 custom-border-radius-12px">
                                <div class="text-center m-3">
                                    <img src="../assets/img/coming.png" style="max-width:50px" />
                                    <h3 class="custom-24px-500">Coming Soon</h3>
                                </div>
                               
                            </CCard>
                        </CCol>
                     </CRow>
                    </CCol>
    
                </CRow>
    
    
            </CCol>
    
        </CCol>
    
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            leaveOptions: [{
                    id: 1,
                    name: 'Annual Leave'
                },
                {
                    id: 2,
                    name: 'Emergency Leave'
                },
                {
                    id: 3,
                    name: 'Maternity Leave'
                },
                {
                    id: 3,
                    name: 'Paternity Leave'
                },
            ],
            "events": [{
                    "id": 1,
                    "start": "2024-08-10T10:00:00",
                    "end": "2024-08-10T11:00:00",
                    "title": "Event Title",
                    "description": "Event Description"
                },
                // More events
            ],
            startDate: new Date(),
            defaultView: 'month', // Default view to month
            timeoffTableData: []

        }





    },
    async mounted() {
        this.$nextTick(() => {
   this.setCalendarView();
});
    //     try {
    //         const isAuth = await this.UserAuth();
    //         if (isAuth) {

    //         } else {
    //             this.GoToPage();
    //             this.$nextTick(() => {
    //   this.setCalendarView();
    // });
    //         }
    //     } catch (error) {
    //         this.GoToPage();
    //         console.error("Error during authentication:", error);
    //         // Handle the error here
    //     }

    },

    computed: {

    },
    created() {
    this.setDefaultMonth();
  },
    methods: {
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        GoToPage() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
       
        onDayClick(date) {
      console.log('Date clicked:', date);
      // Handle day click event
    },
    setCalendarView() {
      const vueCal = this.$refs.vueCal;
      if (vueCal) {
        vueCal.setView(this.defaultView); // Set the calendar view to month
      }
    },
    submitClaim() {
      // Perform any submit logic here
      // After the logic, redirect to another page
      this.$router.push("/ApplyFinancialClaim");
    },


    }

};
</script>